const store = {
    namespaced: true,
    state() {
        return {
            auth: {
                phone: '',
                email: '',
                code: ''
            },
            successMessage: '',
            token: null,
            refreshToken: null,
            profile: {
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                birthday: 0,
                balance: 0,
                status: '',
                can_use_promocode: false
            },
            authFromCart: false
        };
    },
    getters: {
        getState(state) {
            return state;
        },
        getSuccessMessage(state) {
            return state.successMessage;
        },
        getProfileToken(state) {
            return state.token;
        },
        isAuthorized(state) {
            return !!state.token;
        }
    },
    mutations: {
        setAuthPhone(state, data) {
            state.auth.phone = data;
        },
        setAuthEmail(state, data) {
            state.auth.email = data;
        },
        setToken(state, token) {
            state.token = token;
            if (token) {
                this.$cookies.set('AuthToken', token, {
                    path: '/',
                    maxAge: 2 * 24 * 60 * 60
                });
                this.$axios.setToken(token, 'Bearer');
            } else {
                this.$cookies.remove('AuthToken');
                this.$cookies.remove('user-group-id');
                this.$axios.setToken(false);
            }
        },
        setRefreshToken(state, token) {
            state.refreshToken = token;
            if (token) {
                this.$cookies.set('RefreshToken', token, {
                    path: '/',
                    maxAge: 2 * 24 * 60 * 60
                });
            } else {
                this.$cookies.remove('RefreshToken');
            }
        },
        setProfile(state, data) {
            state.profile = data;
        },
        setAuthFromCart(state, data) {
            state.authFromCart = data;
        },
        setSuccessMessage(state, data) {
            state.successMessage = data;
        }
    },
    actions: {
        getAuthCode({ commit }, phone) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .get('/api/v1/sms-code', {
                        params: { phone }
                    })
                    .then(response => {
                        commit('setAuthPhone', phone);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        getAuthCodeByEmail({ commit }, email) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .get('/api/v1/email-code', {
                        params: { email }
                    })
                    .then(response => {
                        commit('setAuthEmail', email);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        socialAuthentification: async function ({ commit, dispatch }, { access, strategy }) {
            // try {
            const { data } = await this.$axios({
                method: 'POST',
                url: `/users/google-auth/`,
                data: {
                    access_token: access,
                    platform: strategy
                }
            });

            const newAccess = data.access_token;
            const newRefresh = data.refresh_token;

            commit('setToken', newAccess);
            commit('setRefreshToken', newRefresh);
        },
        login({ commit, dispatch }, data) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .post('/auth/jwt/create/', data)
                    .then(response => {
                        const resData = response.data;

                        commit('setToken', resData.access);
                        commit('setRefreshToken', resData.refresh);
                        // commit('setProfile', resData.user);
                        // dispatch('favorites/updateList', null, { root: true });
                        // dispatch('favorites/getProducts', null, { root: true });
                        resolve(resData);

                        if (process.client) {
                            setTimeout(() => {
                                window.location.href = window.location.href.split('?')[0];
                            }, 1000);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        loginByEmail({ commit, dispatch }, data) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .post('/api/v1/loginByEmail', data)
                    .then(response => {
                        const resData = response.data;
                        commit('setToken', resData.token);
                        commit('setProfile', resData.user);
                        dispatch('favorites/updateList', null, { root: true });
                        dispatch('favorites/getProducts', null, { root: true });
                        resolve(resData);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        logout({ commit }) {
            commit('setToken', null);
            commit('setRefreshToken', null);
            commit('setProfile', {
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                birthday: 0,
                balance: 0,
                status: '',
                can_use_promocode: false
            });
            if (this.$router.currentRoute.name) {
                this.$router.push(this.localePath('/'));
            } else {
                setTimeout(() => {
                    window.location.href = window.location.href.split('?')[0];
                }, 1000);
            }
            if (process.client) {
                setTimeout(() => {
                    window.location.href = window.location.href.split('?')[0];
                }, 1000);
            }
        },
        getProfile({ commit, getters }) {
            const token = getters.getProfileToken || this.$cookies.get('AuthToken');
            return new Promise((resolve, reject) => {
                this.$axios
                    .get('/users/user-group/', {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                    .then(async response => {
                        const data = response.data;

                        const userGroupId = response?.data?.[0]?.group_user_type?.id;
                        const userGroupIdInCookie = this.$cookies.get('user-group-id') || null;

                        if (!userGroupIdInCookie && userGroupId) {
                            await this.$cookies.set('user-group-id', userGroupId);
                        }

                        commit('setProfile', data);
                        resolve(data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        updateProfile({ commit }, data) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .patch('/api/v1/user', data)
                    .then(response => {
                        const resData = response.data;
                        commit('setProfile', resData);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    }
};

export default store;
